<template>
  <el-dialog
    v-if="showAfterRequest"
    title="竞价记录"
    :visible.sync="showDialog"
    width="700px"
    class="dialog"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <div v-if="tableList.length" class="section">
      <el-table
        border
        class="section"
        highlight-current-row
        style="width: 100%"
        header-row-class-name="table-header"
        size="medium"
        :data="tableList"
      >
        <el-table-column
          label="排名"
          prop="index"
          align="center"
          type="index"
          width="60"
        />
        <el-table-column label="报价方" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.supplierName"
              placement="top"
            >
              <div class="text-ellipsis">
                {{ row.supplierName || ' - ' }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="最新报价（元）"
          align="right"
          header-align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div class="text-ellipsis">
              {{ row.offerAmount ? strToThousands(row.offerAmount) : ' - ' }}
            </div>
            <money-in-cn :money="row.offerAmount" :show-prefix="false" />
          </template>
        </el-table-column>
        <el-table-column
          label="幅度（元）"
          align="right"
          header-align="center"
          min-width="60"
        >
          <template slot-scope="{ row }">
            <div class="text-ellipsis">
              {{ row.offerRange ? strToThousands(row.offerRange) : ' - ' }}
            </div>
            <money-in-cn :money="row.offerRange" :show-prefix="false" />
          </template>
        </el-table-column>
        <el-table-column label="报价时间" align="center" min-width="100">
          <template slot-scope="{ row }">
            <div class="text-ellipsis">{{ row.offerTime | getNormMinuteFilter }}</div>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="page"
        :limit.sync="size"
        :page-sizes="[5, 10]"
        :pager-count="5"
      />
    </div>
    <div v-else class="has-no-content flex-center">暂无数据</div>
  </el-dialog>
</template>

<script>
// 组件
import Pagination from '@/components/common/Pagination'
import MoneyInCn from '@/components/common/MoneyInCn'
// 工具方法
import { strToThousands } from '@/utils/utils'

export default {
  name: 'CompeteHistory',

  components: { Pagination, MoneyInCn },

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    // 返回Promise的函数
    promiseFun: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      showAfterRequest: false,
      tableList: [],
      token: this.$route.params.token
    }
  },

  watch: {
    showDialog(val) {
      if (val) {
        this.page = 1
        this.size = 10
        this.getList()
      } else {
        this.showAfterRequest = false
      }
    },

    page() {
      this.getList()
    },
    size() {
      this.getList()
    }
  },

  methods: {
    strToThousands,

    // 关闭弹窗
    closeDialog() {
      this.$emit('change', false)
    },

    // 获取竞价记录列表
    getList() {
      const requestResult = this.promiseFun({
        page: this.page,
        size: this.size
      })
      if (!('then' in requestResult)) {
        throw new Error('请传入一个返回Promise的函数')
      }

      requestResult
        .then(res => {
          this.tableList = res.data.records
          this.total = res.data.total
        })
        .catch(err => {
          this.$message.error(err.message)
        })
        .finally(() => {
          this.showAfterRequest = true
        })
    },

    // 更改pageSize，或者切换分页
    changePagination({ page, limit }) {
      this.page = page
      this.size = limit

      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.has-no-content {
  height: pixel-to-rem($n: 500);
  font-size: pixel-to-rem($n: 22);
  color: $third-text-color;
  background-color: $grey-background-color;
}
</style>
